import index from '../../contentBlocks/components/slider.js';
export default index;